import type { DigitalMenuCategory, DigitalMenuPage, DigitalMenuProduct, DigitalMenuProductDetail, DigitalMenuProfile } from 'shared-models';
import { validateEnv } from '../../utils/env.util';

export class DigitalMenuError extends Error {
  constructor(readonly status: number) {
    super(status === 404 || status === 403 ? 'התפריט אינו זמין כרגע' : 'לא ניתן לטעון את התפריט. נסו שוב.');
  }
}

async function readMenu<Result>(tenantId: string, path: string, signal?: AbortSignal): Promise<Result> {
  const base = validateEnv().VITE_BACKEND_LOCATION.replace(/\/$/, '');
  const response = await fetch(`${base}/digital-menu/public/${encodeURIComponent(tenantId)}${path}`, {
    credentials: 'omit', cache: 'no-store', signal,
  });
  if (!response.ok) throw new DigitalMenuError(response.status);
  return response.json() as Promise<Result>;
}

export const digitalMenuService = {
  profile: (tenantId: string, signal?: AbortSignal) => readMenu<DigitalMenuProfile>(tenantId, '', signal),
  categories: (tenantId: string, page: number, signal?: AbortSignal) =>
    readMenu<DigitalMenuPage<DigitalMenuCategory>>(tenantId, `/categories?page=${page}&limit=20`, signal),
  products: (tenantId: string, page: number, categoryId?: number, signal?: AbortSignal, search = '') => {
    const query = new URLSearchParams({ page: String(page), limit: '20' });
    if (categoryId !== undefined) query.set('categoryId', String(categoryId));
    if (search.trim()) query.set('search', search.trim());
    return readMenu<DigitalMenuPage<DigitalMenuProduct>>(tenantId, `/products?${query}`, signal);
  },
  product: (tenantId: string, productId: number, signal?: AbortSignal) =>
    readMenu<DigitalMenuProductDetail>(tenantId, `/products/${productId}`, signal),
};